import { render, staticRenderFns } from "./MessageBox.vue?vue&type=template&id=222569fa&scoped=true&"
import script from "./MessageBox.vue?vue&type=script&lang=js&"
export * from "./MessageBox.vue?vue&type=script&lang=js&"
import style0 from "./MessageBox.vue?vue&type=style&index=0&id=222569fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222569fa",
  null
  
)

export default component.exports